import { DateTime, Interval } from 'luxon';
import { SegmentsForEdit } from '../wizard/time-slot.types';

export const isOverlappingSegment = (
  slot: SegmentsForEdit,
  timeslots: SegmentsForEdit[]
): boolean => {
  const dateTimeSlot = DateTime.fromISO(slot.utcStartDateTime);
  const dateTimeEndSlot = DateTime.fromISO(slot.utcEndDateTime);
  const timeSlotInterval = Interval.fromDateTimes(dateTimeSlot, dateTimeEndSlot);

  const overlappingSlot = timeslots.find((existingSlot) => {
    const existingStart = DateTime.fromISO(existingSlot.utcStartDateTime);
    const existingEnd = DateTime.fromISO(existingSlot.utcEndDateTime);
    const existingInterval = Interval.fromDateTimes(existingStart, existingEnd);

    if (slot.segmentId === existingSlot.segmentId) {
      return false;
    }

    return timeSlotInterval.overlaps(existingInterval);
  });
  return !!overlappingSlot;
};
